<script>
    import IconTag from '@/components/icon/IconTag.vue';
    import constants from '@/constants/index.js';

    export default {
        data() {
            return {
                constants: constants,
            }
        },
        components: {
            ButtonIcon: IconTag,
        }
    }
</script>


<template>
    <router-link 
        class="left_button_main_container"
        :to="{name: constants.ROUTER_NAME.TAGEDIT}"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Tags</label>
        </div>
    </router-link>
</template>